import { render, staticRenderFns } from "./CourseSolo.vue?vue&type=template&id=f3173250&scoped=true"
import script from "./CourseSolo.vue?vue&type=script&lang=js"
export * from "./CourseSolo.vue?vue&type=script&lang=js"
import style0 from "./CourseSolo.vue?vue&type=style&index=0&id=f3173250&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3173250",
  null
  
)

export default component.exports